import React from "react";
import { Typography } from "@mui/material";

const Title = ({ form }) => {
    return (
        <Typography
            variant="body1"
            style={{ fontWeight: "bold", fontSize: "21px" }}
        >
            EP{form.data.epId} - Series {form.data.pullListId}
        </Typography>
    );
};

export default Title;
